import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { blogService } from '@/services/blog';
import BlogTable from '@/components/admin/BlogTable';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AdminLayout } from '@/components/admin/AdminLayout';

const BlogIndexPage: React.FC = () => {
  // Fetch all blog posts for admin view (assuming getPosts without filters gets all)
  const { data: postsData, isLoading, error } = useQuery({
    queryKey: ['adminBlogs'],
    queryFn: () => blogService.getPosts(), // Modify or add a service method if needed to get ALL blogs
  });

  // Placeholder for delete functionality
  const handleDelete = (id: string) => {
    console.log(`Delete blog with ID: ${id}`);
    // TODO: Implement actual delete API call and data refetch/update
  };

  if (isLoading) {
    return <div>Loading blogs...</div>;
  }

  if (error) {
    return <div>Error loading blogs: {(error as Error).message}</div>;
  }

  return (
    <AdminLayout>
      <div className="container mx-auto py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-sauna-navy">Admin Blog Posts</h1>
          <Button asChild>
            <Link to="/admin/blogs/new">Add New Blog</Link>
          </Button>
        </div>
        
        {postsData?.data && postsData.data.length > 0 ? (
          <BlogTable blogs={postsData.data} onDelete={handleDelete} />
        ) : (
          <div className="text-center text-gray-500">No blog posts found in the database.</div>
        )}
      </div>
    </AdminLayout>
  );
};

export default BlogIndexPage; 